import { warn } from '../ltjsUtil';
var textHeightCache = new Map();
var fontMetricsCache = new Map();
var measurementCanvas = null;
var measurementContext = null;
function _getMeasurementContext(fontProperty) {
    if (measurementCanvas === null) {
        measurementCanvas = document.createElement('canvas');
        measurementContext = measurementCanvas.getContext('2d');
    }
    // Important for tight loops
    if (fontProperty !== measurementContext.font) {
        measurementContext.font = fontProperty;
    }
    return measurementContext;
}
function _getElementOffset(domElement) {
    if (domElement === undefined || domElement === null) {
        throw new Error('domElement must not be null in TextUtil._getElementOffset');
    }
    else if (domElement.ownerDocument === undefined || domElement.ownerDocument === null) {
        throw new Error('domElement.ownerDocument must not be null in TextUtil._getElementOffset');
    }
    var docElem = domElement.ownerDocument.documentElement;
    var box = domElement.getBoundingClientRect();
    var win = document.defaultView;
    if (win === undefined || win === null) {
        throw new Error('document.defaultView must not be null in TextUtil._getElementOffset');
    }
    return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft,
    };
}
function getTextHeightImpl(fontProperty, lineHeight) {
    if (lineHeight === void 0) { lineHeight = 'normal'; }
    var cacheKey = fontProperty + lineHeight;
    {
        // check cache
        // NOTE(mikcol): legacy code would remeasure when textHeight was 0
        var textHeightMaybe = textHeightCache.get(cacheKey);
        if (textHeightMaybe !== undefined) {
            return textHeightMaybe;
        }
    }
    var textHeight = 0;
    {
        var text = 'Mg';
        var body = document.getElementsByTagName('body')[0];
        var testDiv = document.createElement('div');
        var testText = document.createTextNode(text);
        testDiv.appendChild(testText);
        testDiv.setAttribute('style', "font: ".concat(fontProperty, " !important; display: block !important; position: absolute !important; top: 0 !important; bottom: auto !important; line-height: ").concat(lineHeight, " !important; height: auto !important; min-height: 0 !important; max-height: none !important; overflow-wrap: normal !important; padding: 0 !important;"));
        body.appendChild(testDiv);
        textHeight = testDiv.getBoundingClientRect().height;
        body.removeChild(testDiv);
        // S1483992 - Remove unessessary text pad creating problems with word wrap fitting
        //textHeight += TextUtil.TEXT_PADDING * 2;
    }
    textHeightCache.set(cacheKey, textHeight);
    return textHeight;
}
var TextUtil = {
    TEXT_PADDING: 2,
    buildDOMFontProperty: function (fontName, fontSize) {
        var fontStyle = '';
        if (fontName.indexOf(':') >= 0) {
            var lastIndex = fontName.lastIndexOf(':');
            fontStyle = fontName.substring(0, lastIndex);
            fontName = fontName.substring(lastIndex + 1);
            fontStyle += ' ';
        }
        return "".concat(fontStyle).concat(fontSize, "px ").concat(fontName);
    },
    buildDOMFontPropertyFromComputedStyle: function (style) {
        return [style.fontStyle, style.fontWeight, style.fontSize, style.fontFamily].join(' ');
    },
    getFontMetricsForFontProperty: function (fontProperty) {
        {
            var metricsMaybe = fontMetricsCache.get(fontProperty);
            if (metricsMaybe) {
                return metricsMaybe;
            }
        }
        var metrics = [0, 0, 0, 0];
        // http://stackoverflow.com/questions/1134586/how-can-you-find-the-height-of-text-on-an-html-canvas
        {
            var body = document.getElementsByTagName('body')[0];
            var testDiv = document.createElement('div');
            var testText = document.createElement('span');
            testText.style.font = fontProperty;
            // This is needed to get valid results in some environments, such as the web-sdk-test app.
            testText.appendChild(document.createTextNode('Mg'));
            var testBlock = document.createElement('div');
            testBlock.style.display = 'inline-block';
            testBlock.style.width = '1px';
            testBlock.style.height = '0px';
            testDiv.appendChild(testText);
            testDiv.appendChild(testBlock);
            body.appendChild(testDiv);
            testBlock.style.verticalAlign = 'bottom';
            metrics[0 /* FontMetricProps.lineHeight */] = _getElementOffset(testBlock).top - _getElementOffset(testText).top;
            testBlock.style.verticalAlign = 'baseline';
            metrics[1 /* FontMetricProps.ascent */] = _getElementOffset(testBlock).top - _getElementOffset(testText).top;
            metrics[2 /* FontMetricProps.descent */] = metrics[0 /* FontMetricProps.lineHeight */] - metrics[1 /* FontMetricProps.ascent */];
            // TODO(legacy): more intelligent capHeight
            metrics[3 /* FontMetricProps.capHeight */] = metrics[1 /* FontMetricProps.ascent */];
            body.removeChild(testDiv);
        }
        fontMetricsCache.set(fontProperty, metrics);
        return metrics;
    },
    getFontMetrics: function (fontName, fontSize) {
        var fontProperty = TextUtil.buildDOMFontProperty(fontName, fontSize);
        return TextUtil.getFontMetricsForFontProperty(fontProperty);
    },
    getTextHeight: function (fontName, fontStyle, fontWeight, fontSize, lineHeight) {
        if (typeof fontName === 'object') {
            fontStyle = fontName['font-style'];
            fontWeight = fontName['font-weight'];
            fontSize = fontName['font-size'];
            fontName = fontName['font-family'];
        }
        // add prefix to fontName (fontWeight fontStyle:)
        // NOTE(mikcol): legacy code did not add a ' ' between fontWeight and fontName if fontStyle was falsey
        if (fontStyle) {
            fontName = fontStyle + ':' + fontName;
        }
        if (fontWeight) {
            fontName = fontWeight + ' ' + fontName;
        }
        var fontProperty = TextUtil.buildDOMFontProperty(fontName, fontSize);
        return getTextHeightImpl(fontProperty, lineHeight);
    },
    getTextHeightFromStyle: function (style) {
        return getTextHeightImpl(TextUtil.buildDOMFontPropertyFromComputedStyle(style), style.lineHeight);
    },
    getTextWidth: function (text, fontName, fontSize) {
        if (!text) {
            return 0;
        }
        var fontProperty = TextUtil.buildDOMFontProperty(fontName, fontSize);
        var ctx = _getMeasurementContext(fontProperty);
        var width = 0;
        var lines = text.split('\n');
        for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
            var line = lines_1[_i];
            width = Math.max(width, ctx.measureText(line).width);
        }
        // S1483992 - Remove unessessary text pad creating problems with word wrap fitting
        return width; // + TextUtil.TEXT_PADDING * 2;
    },
    /**
     * Computes the longest string in an array of items or the length of a single item and returns this value.
     * @param {string[]|string} text - the text item or list of text items that you want to measure.
     * @param {object} style - the style bundle that is used to compute the font window.getComputedStyle(domElement) is one way to generate this object.
     * @param {Number} maxSize (optional) - the largest width that a string is allowed.
     * @param {Function} formatValueCallback (optional) - Formatter for the text items. Must return a string.
     * @returns {Number} The longest measured text width.
     */
    getTextWidthFromComputedStyle: function (textOrTexts, style, maxSize, formatValueCallback) {
        if (!style || !style.fontStyle || !style.fontWeight || !style.fontSize || !style.fontFamily) {
            warn('Invalid style object');
            return 0;
        }
        var fontProperty = TextUtil.buildDOMFontPropertyFromComputedStyle(style);
        maxSize = maxSize || Number.MAX_VALUE;
        var ctx = _getMeasurementContext(fontProperty);
        if (!Array.isArray(textOrTexts)) {
            var text = textOrTexts;
            if (formatValueCallback) {
                text = formatValueCallback(text);
            }
            return Math.min(maxSize, ctx.measureText(text).width);
        }
        else {
            var textStrings = textOrTexts;
            var longestWidth = 0;
            for (var i = 0, len = textStrings.length; i < len; ++i) {
                var text = textStrings[i];
                if (formatValueCallback) {
                    text = formatValueCallback(text);
                }
                longestWidth = Math.max(longestWidth, ctx.measureText(text).width);
                if (longestWidth >= maxSize) {
                    return maxSize;
                }
            }
            return longestWidth;
        }
    },
    clearFontCache: function () {
        textHeightCache.clear();
        fontMetricsCache.clear();
    },
};
export default TextUtil;
